import { Share2, Facebook, Twitter, Link, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { useState } from "react";

const ShareButton = ({ config, price }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const getShareText = () => {
    const shape = config.shape.charAt(0).toUpperCase() + config.shape.slice(1);
    const dimensions = `${config.width}×${config.height}×${config.depth}ft`;
    return `Check out my custom ${shape} reptile enclosure (${dimensions}) from ReptiCraft! £${price?.toFixed(2) || '0'}`;
  };

  const getShareUrl = () => {
    const baseUrl = window.location.origin;
    const params = new URLSearchParams({
      shape: config.shape,
      width: config.width,
      height: config.height,
      depth: config.depth,
      stain: config.stain_color,
      glass: config.glass_thickness
    });
    return `${baseUrl}/configurator?${params.toString()}`;
  };

  const shareToFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getShareUrl())}&quote=${encodeURIComponent(getShareText())}`;
    window.open(url, "_blank", "width=600,height=400");
  };

  const shareToTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(getShareText())}&url=${encodeURIComponent(getShareUrl())}`;
    window.open(url, "_blank", "width=600,height=400");
  };

  const shareToWhatsApp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(getShareText() + " " + getShareUrl())}`;
    window.open(url, "_blank");
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(getShareUrl());
      toast.success("Link copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy link");
    }
    setShowDropdown(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        size="sm"
        onClick={() => setShowDropdown(!showDropdown)}
        className="border-white/20 text-[#F4F1DE]/80 hover:border-[#E07A5F]/50"
        data-testid="share-button"
      >
        <Share2 className="w-4 h-4 mr-2" />
        Share
      </Button>

      {showDropdown && (
        <div className="absolute right-0 top-full mt-2 bg-[#121212] border border-white/10 rounded-lg shadow-xl overflow-hidden z-50 w-48">
          <button
            onClick={shareToFacebook}
            className="w-full flex items-center gap-3 px-4 py-3 text-[#F4F1DE]/80 hover:bg-white/5 transition-colors"
            data-testid="share-facebook"
          >
            <Facebook className="w-5 h-5 text-blue-500" />
            Facebook
          </button>
          <button
            onClick={shareToTwitter}
            className="w-full flex items-center gap-3 px-4 py-3 text-[#F4F1DE]/80 hover:bg-white/5 transition-colors"
            data-testid="share-twitter"
          >
            <Twitter className="w-5 h-5 text-sky-400" />
            Twitter / X
          </button>
          <button
            onClick={shareToWhatsApp}
            className="w-full flex items-center gap-3 px-4 py-3 text-[#F4F1DE]/80 hover:bg-white/5 transition-colors"
            data-testid="share-whatsapp"
          >
            <MessageCircle className="w-5 h-5 text-green-500" />
            WhatsApp
          </button>
          <button
            onClick={copyLink}
            className="w-full flex items-center gap-3 px-4 py-3 text-[#F4F1DE]/80 hover:bg-white/5 transition-colors border-t border-white/5"
            data-testid="share-copy"
          >
            <Link className="w-5 h-5 text-[#E07A5F]" />
            Copy Link
          </button>
        </div>
      )}
    </div>
  );
};

export default ShareButton;
